// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Text, type TextProps } from "metabase/ui";

import { EntityIcon } from "../EntityIcon";

export const ItemTitle = styled(Text)<TextProps>`
  margin: 0;
  word-break: break-word;
` as unknown as typeof Text;

export const ItemIcon = styled(EntityIcon)`
  justify-self: end;
  color: var(--mb-color-core-brand);
`;

const activeItemCss = css`
  background-color: var(--mb-color-core-brand);
  /* Otherwise a solid fill distinguished only by color (WCAG 1.4.1) — add
     a real ring so the shape doesn't depend on perceiving the fill's hue. */
  outline: 2px solid var(--mb-color-text-primary-inverse);
  outline-offset: -4px;

  ${ItemIcon},
  ${ItemTitle} {
    color: var(--mb-color-text-primary-inverse);
  }
`;

const VERTICAL_PADDING_BY_SIZE = {
  small: "0.5rem",
  medium: "0.75rem",
};

export const BaseItemRoot = styled.li<{
  size: "small" | "medium";
  isSelected: boolean;
}>`
  display: grid;
  align-items: center;
  cursor: pointer;
  padding: ${(props) => VERTICAL_PADDING_BY_SIZE[props.size]} 0.5rem;
  border-radius: 6px;
  margin-bottom: 2px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (hover: hover) {
    &:hover {
      ${activeItemCss}
    }
  }

  ${(props) => props.isSelected && activeItemCss}
`;

const getGridTemplateColumns = (hasLeftIcon: boolean, hasRightIcon: boolean) =>
  // minmax(0, 1fr), not a bare 1fr: a bare 1fr track's automatic minimum
  // size is its content's min-content width, so the title column couldn't
  // shrink below that under browser zoom (WCAG 1.4.4) — minmax(0, 1fr)
  // gives it an explicit 0 floor instead.
  `${hasLeftIcon ? "min-content" : ""} minmax(0, 1fr) ${
    hasRightIcon ? "min-content" : ""
  }`;

export const ItemRoot = styled(BaseItemRoot)<{
  hasLeftIcon: boolean;
  hasRightIcon: boolean;
}>`
  display: grid;
  grid-template-columns: ${(props) =>
    getGridTemplateColumns(props.hasLeftIcon, props.hasRightIcon)};
  gap: 0.5rem;
`;
